module.exports = __webpack_public_path__ + "img/login image b2C.fe61cbab.png";